import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { deDE, nlNL, plPL } from "@mui/x-data-grid";

const LOCALE_MAP = {
  nl: nlNL,
  de: deDE,
  pl: plPL,
};

export const useDataGridLocaleText = () => {
  const { i18n, t } = useTranslation();

  return useMemo(() => {
    const locale = LOCALE_MAP[i18n.language];
    const muiLocaleText = locale?.components?.MuiDataGrid?.defaultProps?.localeText || {};

    return {
      ...muiLocaleText,
      toolbarFilters: t("Grid Filters"),
      toolbarDensity: t("Grid Density"),
      toolbarDensityLabel: t("Grid Density"),
      toolbarDensityCompact: t("Grid Density Compact"),
      toolbarDensityStandard: t("Grid Density Standard"),
      toolbarDensityComfortable: t("Grid Density Comfortable"),
      toolbarFiltersLabel: t("Grid Show filters"),
      toolbarFiltersTooltipHide: t("Grid Hide filters"),
      toolbarFiltersTooltipShow: t("Grid Show filters"),
      toolbarQuickFilterPlaceholder: t("Search"),
      toolbarQuickFilterLabel: t("Search"),
    };
  }, [i18n.language, t]);
};
